module.exports = __webpack_public_path__ + "img/parent-child-4.f04af62c.png";